<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" :persistent="showDetails" max-width="500px")
      v-card
        v-card-title.px-5(v-if="showDetails" :style="`background-color: ${$vuetify.theme.themes[$theme].basic100}`")
          v-row(no-gutters align="center")
            v-col.shrink
              v-btn.ml-n3(text icon @click="showModal = !showModal" height)
                eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].basic800" width="24" height="24")
            v-col.ml-3
              p.mb-0.h6.basic800--text Back to Submit Ideas
        v-card-text.pa-0
          .details.px-4.mb-4(v-if="showDetails")
            .s1.primary500--text {{ idea.published_title }}
            .f2.primary400--text.mt-n1 Posted on  {{ idea.date_published | humanizeDate }} {{ profileDisplay }}

            .p1.primary400--text.mt-4(v-if="idea.published_description") {{ idea.published_description }}

            .image.mt-4(v-if="galleryPhotos.length > 0")
              v-card(flat @click="openPhotoGalleryDialog = true" width="88px" height="88px")
                v-img(:src="galleryPhotos[0].url" aspect-ratio="1")
                  template(v-slot:placeholder)
                    v-row(class="fill-height ma-0" align="center" justify="center")
                      v-progress-circular(indeterminate color="grey")

                    
          .add-vote(v-if="!hasOwnVote")
            v-form.py-6.px-4(ref="form" :class="showDetails ? 'basic200' : ''")
              .label.primary400--text How important is this to you?
              .importance.mt-1
                template(v-for='(importanceItem, index) in importanceItems')
                  v-chip.text-uppercase.button-AA-tiny.ma-1(small outlined label :color="form.data.importance == importanceItem.id ? 'info500' : 'primary500'" :style="{ 'background-color': (form.data.importance == importanceItem.id ? $vuetify.theme.themes[$theme].info500 : $vuetify.theme.themes[$theme].basic400) + '!important' }" :key='importanceItem.id' @click="form.data.importance = importanceItem.id")
                    span(:class="form.data.importance == importanceItem.id ? 'basic100--text' : 'primary500--text'") {{ importanceItem.text }}
              .insight.mt-4
                p.mb-1.label.basic600--text.text-uppercase INSIGHT (Optional)
                v-textarea.mt-2(v-model='form.data.insight' placeholder="How would this feature help your business? Any context you provide will help us make this feature better for you." outlined dense persistent-hint background-color="basic200")
              .email(v-if="!notifiedByEmail")
                y-checkbox.my-auto.mx-0.pa-0(v-model="form.receiveNotification" hide-details)
                  template(v-slot:label)
                    .p1.my-auto Get email updates on this feature
                .notify(v-if="form.receiveNotification")
                  v-text-field.mt-2(v-model='form.data.email' placeholder="Get notified from us for this feature." background-color="basic200" outlined dense height="40" persistent-hint :rules="form.receiveNotification ? rules.email : []")

              v-layout
                v-spacer
                v-btn.px-6(color='info500' depressed dark @click='clickSubmit()' :loading="isLoading")
                  .button-AA-small.basic100--text Submit
          
          .view-vote(v-else)
            v-divider.basic300
            .content.pa-4

              v-row.d-flex.mx-0(align="center")
                intel-avatar.mr-2.mt-1(:code="member.user.avatar_code" :id="member.user.id" size="16")
                .f1.primary400--text Posted on  {{ idea.date_published | humanizeDate }} {{ ownProfileDisplay }}
                v-spacer
                v-chip.text-uppercase.button-AA-tiny(small outlined label color="info500" :style="{ 'background-color': $vuetify.theme.themes[$theme].info500 + '!important' }")
                  span(class="basic100--text") {{ importanceItems.filter(f => f.id == ownVote.importance)[0].text }}

              .p1.primary400--text.mt-4(v-if="ownVote.insight") {{ ownVote.insight }}

              .f1.primary400--text.mt-4 Submitted {{ ownVote.date_created | displayTime }}, {{ ownVote.date_created | humanizeDate }}

    .modals
      PhotoGallery(v-if="openPhotoGalleryDialog" :open.sync="openPhotoGalleryDialog" :photos="galleryPhotos" index="0")
          
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PhotoGallery from '@/components/PhotoGallery'
import IntelAvatar from '@/components/IntelAvatar.vue'

export default {
  name: 'VoteIdeaDialog',
  props: ['open', 'parentIdea', 'showDetails', 'hasOwnVote', 'votes', 'profile'],
  components: { PhotoGallery, IntelAvatar },
  data: () => ({
    form: {
      data: {
        importance: 'good_to_have',
        insight: '',
        email: null
      },
      receiveNotification: false
    },
    importanceItems: [
      { id: 'nice_to_have', text: 'Nice to have'},
      { id: 'good_to_have', text: 'Good to Have'},
      { id: 'must_have', text: 'Must Have'}
    ],
    rules: {
      email: [
        v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
      ]
    },
    notifications: [],
    openPhotoGalleryDialog: false,
    isLoading: false
  }),
  computed: {
    ...mapState('user', ['feedbackApiUser', 'member']),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    idea: {
      get() {
        return this.parentIdea
      },
      set(newValue) {
        this.$emit('edited', newValue)
      }
    },
    profileDisplay () {
      if (!this.profile) {
        return ''
      }
      return `by ${this.profile.name}, ${this.profile.company}`
    },
    ownVote () {
      if (!this.votes) {
        return null
      }
      return (this.votes.filter(v => v.user_id == this.feedbackApiUser.id) || [])[0]
    },
    ownProfileDisplay () {
      if (!this.feedbackApiUser.profile) {
        return ''
      }
      return `by ${this.feedbackApiUser.profile.name}, ${this.feedbackApiUser.profile.company}`
    },
    galleryPhotos () {
      if (!this.idea.published_image) {
        return []
      }
      return [{ url: `${process.env.VUE_APP_FEEDBACK_API_URL}/assets/${this.idea.published_image.id}?access_token=${this.feedbackApiUser.token}` }]
    },
    notifiedByEmail () {
      if (this.notifications.length > 0) {
        return true
      }
      return false
    }
  },
  mounted () {
    if (this.member.user && this.member.user.email) {
      this.form.data.email = this.member.user.email
    }
    if (!this.hasOwnVote) { 
      this.getOwnNotifications()
    }
  },
  methods:{
    ...mapActions([
      'showMessage'
    ]),
    getOwnNotifications () {
      this.$feedbackApi.get(`/items/notifications?filter={"_and":[{"feedback_id":{"_eq":"${this.idea.id}"}},{"user_id":{"_eq":"${this.feedbackApiUser.id}"}}]}`).then((response) => {
        if (response.data.data.length > 0) {
          this.notifications = response.data.data
        }
      }).catch(() => {})
    },
    clickSubmit () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      const data = {
        feedback_id: this.idea.id,
        importance: this.form.data.importance,
        insight: this.form.data.insight,
      }
      this.$feedbackApi.post('/items/votes', data)
        .then((response) => {
          this.$emit('vote-added', response.data.data)
          this.$feedbackApi.patch(`/items/feedbacks/${this.idea.id}`, { vote_count: this.idea.vote_count + 1 }).catch(() => {})
          this.parentIdea.vote_count = this.parentIdea.vote_count + 1
          this.idea = this.parentIdea
          if (this.form.receiveNotification) {
            const data = {
              email: this.form.data.email,
              feedback_id: this.idea.id,
              contributor_id: 1
            }
            this.$feedbackApi.post('/items/notifications', data).catch(() => {})
          }
          this.showMessage(['success', this.$t('success_message.response_recorded')])
          this.showModal = false
        }).catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => { this.isLoading = false })
    }
  },
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "cancel": "Cancel",
    "submit": "Submit"
  },

  "id": {
    "cancel": "Batal",
    "submit": "Hantar"
  }
}
</i18n>
